import {
  BorderOutlined,
  CoffeeOutlined,
  HomeOutlined,
  MedicineBoxOutlined,
  TagsOutlined
} from "@ant-design/icons";

const PRIM_KIND_UI = {
  1: { icon: HomeOutlined, color: "#1677ff" },
  3: { icon: TagsOutlined, color: "#d48806" },
  2: { icon: CoffeeOutlined, color: "#389e0d" },
  4: { icon: BorderOutlined, color: "#13c2c2" },
  5: { icon: MedicineBoxOutlined, color: "#722ed1" }
};

export const primKindUi = (vid) => PRIM_KIND_UI[vid] || PRIM_KIND_UI[1];

export const PrimKindIcon = ({ vid, className }) => {
  const Icon = primKindUi(vid).icon;
  return <Icon className={className} />;
};

export const primCountForVid = (byVid, vid) => {
  const ids = byVid?.[vid];
  return Array.isArray(ids) ? ids.length : 0;
};
